module.exports = __webpack_public_path__ + "img/13.96013a87.png";